import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import FontAwesome from 'react-fontawesome';
import FeatureFlagView from '~/Components/Global/FeatureFlagView/FeatureFlagView';
import {
  getDeletedUserLists,
  getUserLists,
  toggleRecover,
} from '~/Redux/Modules/UserLists/actions';

import './Toolbar.scss';

const RecoveryModeToggle = ({ toggleRecover, inRecoveryMode }) => {
  return (
    <FeatureFlagView featureName="LIST_RECOVERY">
      <button
        onClick={() => toggleRecover(inRecoveryMode)}
        className={inRecoveryMode ? `quill-button active` : `quill-button`}
      >
        <FontAwesome className="listUndoIcon" name="undo" size="lg" title="Recover List" />
      </button>
    </FeatureFlagView>
  );
};

const mapStateToProps = ({ UserLists: { lists } }) => {
  return {
    inRecoveryMode: lists.inRecoveryMode,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getDeletedUserLists: () => dispatch(getDeletedUserLists()),
    getUserLists: () => dispatch(getUserLists()),
    toggleRecover: toggle => {
      console.log('toggleRecover => toggle: ' + toggle);
      if (toggle) {
        dispatch(getUserLists());
      } else {
        dispatch(getDeletedUserLists());
      }
      return dispatch(toggleRecover(toggle));
    },
  };
};

RecoveryModeToggle.propTypes = {
  toggleRecover: propTypes.func,
  inRecoveryMode: propTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryModeToggle);
